import { ReactElement, useEffect } from 'react';
import { SiteListCard } from '@components/lms/siteListWrapper/components/siteListCard/siteListCard';
import { useInfiniteScroll } from '@components/common';
import { Wrapper } from '@components/common/Wrapper/wrapper';
import { useSiteListRxDb } from '@services/hooks/lms/siteList/useSiteListRxDb';
import { useSiteListFilterStore } from '@store/lms/siteListFilterStore';
import { NoDataFound } from '@components/common/no-data-found/noDataFound';

export const UpcomingSiteListTaskList = (): ReactElement => {
	const { fetchMore, isFetching, result } = useSiteListRxDb('Upcoming');
	const { updateFilter, siteListFilter } = useSiteListFilterStore();

	useEffect(() => {
		updateFilter({
			...siteListFilter,
			site_current_status_c: 'Upcoming',
		});
		return (): void => {
			updateFilter({
				...siteListFilter,
				site_current_status_c: '',
			});
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useInfiniteScroll(() => {
		fetchMore();
	});

	return (
		<Wrapper isLoaderVisible={isFetching && result.length === 0} isError={null}>
			<div className="common-list-card">
				<ul className="row">
					{result.length > 0 ? (
						result.map((site) => <SiteListCard key={site._data.id} site={site._data} isContractorSite={false} />)
					) : (
						<NoDataFound message="No Upcoming Sites Found!" />
					)}
				</ul>
			</div>
		</Wrapper>
	);
};
